<template>
  <div class="py-3 ipmodal-main-overflow">
    <b-overlay :show="showSearchLoader" class="h-100">
      <section class="d-flex h-100">
        <section class="createjobs-teams-left-container h-100">
          <div class="relativeclass w-100 teams-innerInputField">
            <img
              class="teams-setImage"
              src="../../../assets/img/search-bar-icon.svg"
              alt=""
            />

            <b-form-input
              placeholder="Search Interview Process"
              type="search"
              class="search-input"
              v-model.trim="searchQuery"
              @update="onSearch"
              debounce="500"
            >
            </b-form-input>
          </div>

          <div
            class="overflow-auto"
            style="height: calc(100vh - 395px)"
            id="scrollToTop"
            @scroll="onScroll"
          >
            <template
              v-if="
                (searchQuery == '' && alldata && alldata.length !== 0) ||
                (searchQuery !== '' && alldata && alldata.length !== 0)
              "
            >
              <div
                @click="getId(int)"
                :class="
                  int.interviewProcessID == selectedRoundExists
                    ? 'common-selected-card'
                    : 'pointer'
                "
                class="
                  common-white-card
                  pointer
                  d-flex
                  align-items-center
                  mt-2
                  mr-1
                "
                v-for="(int, index) in alldata"
                :key="index"
              >
                <b-card>
                  <div class="new-center-radio">
                    <b-form-radio
                      v-model="selectedRound"
                      :value="int"
                      @change="interviewData"
                    />
                  </div>
                  <div class="ipModal-content-font text-truncate">
                    {{ int.name }}
                  </div>
                </b-card>
              </div>
              <div class="d-flex justify-content-center m-3" v-if="showLoader">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="searchQuery !== '' && alldata && alldata.length == 0"
            >
              <div
                class="
                  h-100
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                  w-100
                "
              >
                <div>
                  <img
                    src="../../../assets/new-createjobs/no-matching-results.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 teams-empty-container-font">
                  No matching results for "{{ searchQuery }}"
                </div>
              </div>
            </template>
          </div>
        </section>

        <section class="w-70 ml-2 h-100">
          <template
            v-if="selectedRound && Object.keys(selectedRound).length !== 0"
          >
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="ipmodal-right-head text-truncate">
                {{ selectedRound.name }}
              </div>
              <div class="ipmodal-right-head-two d-flex align-items-center">
                <!-- for edit -->
                <template v-if="selectedRoundExists">
                  <div
                    v-if="!editRound && roles.includes('PUT_INTERVIEW')"
                    @click="editorDiscardorDeleteRound('edit', '')"
                    class="d-flex align-items-center mr-3"
                  >
                    <img
                      class="mr-2 pointer"
                      src="@/assets/new-createjobs/edit-svg.svg"
                      alt=""
                    />
                    <div class="pointer">Edit</div>
                  </div>
                  <div
                    v-else-if="editRound"
                    class="d-flex align-items-center mr-3"
                  >
                    <div
                      class="mr-3 pointer"
                      @click="editorDiscardorDeleteRound('discard', '')"
                    >
                      Discard Changes
                    </div>
                    <div class="mr-3">
                      <img src="@/assets/new-createjobs/Line.svg" alt="" />
                    </div>
                    <div
                      :class="disableSave ? 'ip-opacity' : 'pointer'"
                      @click="!disableSave ? (cloneModal = true) : ''"
                    >
                      Save as new
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="w-100" style="height: calc(100vh - 375px)">
              <div
                class="overflow-auto mt-2"
                id="scrollTobottom"
                :class="
                  editRound && tabs.length != 10
                    ? 'check-height-class'
                    : 'check-noAdd-height-class'
                "
              >
                <draggable :list="tabs">
                  <div
                    class="d-flex align-items-center w-100 px-1"
                    v-for="(round, index) in tabs"
                    :key="index"
                    :class="index !== tabs.length - 1 ? 'mb-3' : 'mb-0'"
                  >
                    <div style="width: 40px" v-if="editRound">
                      <img
                        src="@/assets/customfield/dragndrop.svg"
                        alt=""
                        class="pointer"
                      />
                    </div>

                    <div
                      class="common-white-card"
                      :style="!editRound ? 'width:100%' : 'width: 93%'"
                    >
                      <b-card v-if="!editRound">
                        <div class="d-flex align-items-center w-100">
                          <div class="d-flex w-60">
                            <div class="mr-2">
                              <img
                                v-if="round.type == 'assesment'"
                                src="@/assets/new-createjobs/assessment.svg"
                                alt=""
                              />
                              <img
                                v-else-if="round.type == 'f2f'"
                                src="@/assets/new-createjobs/f2f.svg"
                                alt=""
                              />
                            </div>
                            <div class="main-head-ipmodal text-truncate">
                              {{ round.name }}
                            </div>
                          </div>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-end
                              w-40
                            "
                          >
                            <div class="common-sm-blue-box">
                              {{
                                round.type == "assesment"
                                  ? "Assesment"
                                  : "Face to Face"
                              }}
                            </div>
                          </div>
                        </div>
                      </b-card>
                      <b-card v-else>
                        <div class="d-flex align-items-center w-100">
                          <div class="d-flex w-60">
                            <div class="d-flex common-switchParent">
                              <div
                                class="common-switchChild"
                                @click="toggleSwitch(round, 'assesment')"
                              >
                                <img
                                  v-if="round.type === 'assesment'"
                                  src="@/assets/new-createjobs/selec-assess.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="@/assets/new-createjobs/unselect-assess.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                class="common-switchChild"
                                @click="toggleSwitch(round, 'f2f')"
                              >
                                <img
                                  v-if="round.type === 'f2f'"
                                  src="@/assets/new-createjobs/selec-f2f.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="@/assets/new-createjobs/unselec-f2f.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                            <div class="ml-3 d-flex align-items-center">
                              <b-form-input
                                v-model.trim="round.name"
                                :class="
                                  $v.tabs.$each[index].$error ||
                                  duplicateRoundName[index]
                                    ? 'oneline-error'
                                    : 'oneline-inputField'
                                "
                                @input="triggerValidation(index)"
                              >
                              </b-form-input>
                              <div
                                v-if="
                                  $v.tabs.$each[index].name.$dirty &&
                                  !$v.tabs.$each[index].name.required
                                "
                              >
                                <img
                                  v-b-tooltip.hover.top="'Required'"
                                  class="newIcons-hover ml-3"
                                  src="@/assets/new-createjobs/new-validation-icon.svg"
                                  alt="Validation icon"
                                />
                              </div>
                              <div
                                v-else-if="
                                  !$v.tabs.$each[index].name.maxLength &&
                                  $v.tabs.$each[index].name.required
                                "
                              >
                                <img
                                  v-b-tooltip.hover.top="
                                    'Should not exceed 128 characters'
                                  "
                                  class="newIcons-hover ml-3"
                                  src="@/assets/new-createjobs/new-validation-icon.svg"
                                  alt="Validation icon"
                                />
                              </div>
                              <div v-else-if="duplicateRoundName[index]">
                                <img
                                  v-b-tooltip.hover.top="' Name already exists'"
                                  class="newIcons-hover ml-3"
                                  src="@/assets/new-createjobs/new-validation-icon.svg"
                                  alt="Validation icon"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-end
                              w-40
                            "
                          >
                            <div class="common-sm-blue-box mr-3">
                              {{
                                round.type == "assesment"
                                  ? "Assesment"
                                  : "Face to Face"
                              }}
                            </div>
                            <div
                              @click="
                                tabs.length > 1
                                  ? editorDiscardorDeleteRound('delete', index)
                                  : ''
                              "
                            >
                              <img
                                :class="
                                  tabs.length > 1 ? 'pointer' : 'ip-opacity'
                                "
                                class="newIcons-hover"
                                src="../../../assets/new-createjobs/delete-icon.svg"
                                alt=""
                              />
                              <!-- v-b-tooltip.hover.top="'Delete'" -->
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </div>
                </draggable>
              </div>

              <div
                class="d-flex align-items-center w-100"
                v-if="editRound && tabs.length != 10"
              >
                <div style="width: 40px"></div>
                <div
                  class="common-blue-card"
                  :class="
                    disableNewRound || disableSave
                      ? 'common-blue-card-disabled'
                      : 'pointer'
                  "
                  style="width: 93%"
                  @click="!disableNewRound || !disableSave ? addnewRound() : ''"
                >
                  <b-card>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        w-100
                      "
                    >
                      <div
                        class="d-flex align-items-center"
                        :class="
                          disableNewRound || disableSave
                            ? 'defaultCursor'
                            : 'pointer'
                        "
                      >
                        <img
                          class="mr-2"
                          src="../../../assets/new-createjobs/blue-plus-icon.svg"
                          alt=""
                        />
                        <span class="ipmodal-addround-font">
                          Add New Round
                        </span>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="
                h-100
                d-flex
                flex-column
                align-items-center
                justify-content-center
                w-100
              "
            >
              <div>
                <img
                  src="../../../assets/new-createjobs/no-data-icon.svg"
                  alt=""
                />
              </div>
              <div class="mt-2 not-selectround-font">
                Please select any interview process on the left side to view its
                content
              </div>
            </div>
          </template>
        </section>
      </section>
    </b-overlay>

    <CloneModal
      @handle-resetClone="resetClone"
      :cloneModal="cloneModal"
      :duplicatecloneName="duplicateCloneName"
      header="Save Interview Process"
      subHeader="Interview Process Name"
      placeholder="Enter"
      errorMessage="Interview Process Name exists"
      @closeCloneModal="closeCloneModal"
      @handle-clone="saveNew"
      @change-duplicate-name="duplicateCloneName = false"
      buttonName="Save"
      :buttonLoader="buttonLoader"
    />
  </div>
</template>

<script>
import {
  getintprocess,
  putintprocess,
  addintprocess,
} from "../../../utils/apiFunctions.js";
import { mapGetters } from "vuex";
import CloneModal from "../../../views/InterviewProcess/cloneModal.vue";
import { required, maxLength } from "vuelidate/lib/validators";

import draggable from "vuedraggable";

export default {
  name: "InterviewProcessModal",
  components: {
    CloneModal,
    draggable,
  },
  props: {
    interviewProcessID: String,
  },
  data() {
    return {
      duplicateRoundName: [],

      previousTabs: [],
      buttonLoader: false,

      cloneModal: false,
      showSearchLoader: false,
      selectedRound: {},
      editRound: false,
      alldata: [],
      tabs: [
        {
          id: null,
          name: "",
          type: null,
          feedbackform: {
            name: "",
            feedbackFormID: "",
          },
          duration: "",
          randomizeTest: false,
          roundIndex: null,
          duplicateName: false,

          testID: [],
        },
      ],
      duplicateCloneName: false,
      showLoader: false,
      total: null,
      page: 0,
      pageEnd: 0,
      sortColumn: "updatedAt",
      sortOrder: "-1",
      searchQuery: "",
      interviewName: "",
      processID: "",
    };
  },
  validations() {
    return {
      tabs: {
        $each: {
          name: {
            required,
            maxLength: maxLength(128),
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["roles"]),
    disableSave() {
      return this.duplicateRoundName?.includes(true) || this.$v.$invalid;
    },

    disableNewRound() {
      return this.tabs.some((val) => val.name == "");
    },

    selectedRoundExists() {
      return (
        this.selectedRound && this.selectedRound.interviewProcessID != undefined
      );
    },
  },
  async created() {
    if (this.interviewProcessID) {
      this.processID = this.interviewProcessID;
    }
    await this.getInterview();
    this.interviewData();
  },
  watch: {
    disableSave(newValue) {
      this.$emit("update-disable-save", newValue);
    },
    tabs: {
      handler(newRounds) {
        this.duplicateRoundName = newRounds?.map((_, index) => {
          const currentName = newRounds[index]?.name.toLowerCase();
          return newRounds.some(
            (skill, i) =>
              i !== index && skill.name.toLowerCase() === currentName
          );
        });
      },
      deep: true,
    },
  },

  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollContainer = document.getElementById("scrollTobottom");

        scrollContainer.scrollBy({
          top: 1000,
          behavior: "smooth",
        });
      });
    },
    triggerValidation(index) {
      this.$v.tabs.$each[index].$touch();
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader &&
          this.alldata.length
        ) {
          this.showLoader = true;
          this.page++;
          this.getInterview();
        }
      }
    },
    onSearch() {
      this.selectedRound = {};
      this.page = 0;
      this.getInterview();
      this.showSearchLoader = true;
    },
    saveNew(cloningName) {
      this.interviewName = cloningName;
      this.buttonLoader = true;
      this.editInterviewProcess();
    },
    closeCloneModal() {
      this.cloneModal = false;
    },
    editorDiscardorDeleteRound(val, index) {
      if (val == "edit") {
        this.editRound = true;
      } else if (val == "discard") {
        this.tabs = JSON.parse(JSON.stringify(this.previousTabs));
        this.editRound = false;
      } else if (val == "delete") {
        this.tabs.splice(index, 1);
      }
    },
    getId(int) {
      this.selectedRound = int;
      this.interviewData();
    },
    interviewData() {
      this.tabs = [];
      this.editRound = false;
      this.processID = this.selectedRound.interviewProcessID;
      if (this.selectedRound && this.selectedRound.process) {
        for (let n in this.selectedRound.process) {
          const process = this.selectedRound.process[n];

          if (
            process.id != 0 &&
            process.id != "F" &&
            process.id != "H" &&
            process.id != "NI" &&
            process.id != "R"
          ) {
            let feedform = {
              name: "",
              feedbackFormID: "",
            };

            this.tabs.push({
              id: process.id,
              name: process.name,
              type: process.type,
              feedbackform: feedform,
              duration: "",
              randomizeTest: false,
              testID: [],
            });
          }
        }
        this.previousTabs = JSON.parse(JSON.stringify(this.tabs));
      }
    },
    toggleSwitch(round, type) {
      round.type = type;
    },
    async getInterview() {
      let payload = {
        type: "1",
        page: this.page,
        count: 15,
        searchQuery: this.searchQuery,
        sortBy: this.sortColumn,
        order: this.sortOrder,
      };
      if (this.interviewProcessID) {
        payload.interviewProcessID = this.interviewProcessID;
        payload.selected = true;
      }
      try {
        const response = await getintprocess(payload);
        if (response.status == 200) {
          this.$emit("handle-spinner");
          this.showSearchLoader = false;
          if (this.page == 0) {
            this.alldata = response.data.data.data;
          } else {
            this.alldata = [...this.alldata, ...response.data.data.data];
          }
          this.total = response.data.data.total;
          this.pageEnd = response.data.data.pageEnd;
          this.showLoader = false;
          // this.showLoader =
          //   response.data.data.total !== response.data.data.pageEnd;
          if (this.processID) {
            this.selectedRound = this.alldata.find(
              (item) => item.interviewProcessID === this.processID
            );
          }
        }
      } catch (error) {
        console.error("Error fetching feedback forms:", error);
      } finally {
        this.LoaderStatus = false;
        this.showSearchLoader = false;
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    async editInterviewProcess() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.tabs = this.tabs.map((tab, index) => {
            tab.id = index + 1;
            return tab;
          });
          let data = {};
          data["name"] = this.cloneModal
            ? this.interviewName
            : this.selectedRound.name;
          data["numberOfRounds"] = this.tabs.length;
          data["interviewProcessID"] = this.selectedRound.interviewProcessID;
          for (let i in this.tabs) {
            this.tabs[i].feedbackFormID = null;

            if (this.tabs[i].type == "f2f") {
              this.tabs[i].startDate = "";
              this.tabs[i].endDate = "";
            } else {
              this.tabs[i].openTestdt = "";
              this.tabs[i].closeTestdt = "";
            }
          }
          data["process"] = this.tabs;
          let response = {};
          if (this.cloneModal) {
            response = await addintprocess(data);
          } else {
            response = await putintprocess(data);
          }
          if (response.status == 200) {
            if (response.data.data?.interviewProcessID) {
              this.processID = response.data.data.interviewProcessID;
              this.closeCloneModal();
            }
            await this.getInterview();
            this.buttonLoader = false;
            this.editRound = false;
          } else if (response.status == 409) {
            this.duplicateCloneName = true;
            this.buttonLoader = false;
          }
        } catch (error) {
          this.buttonLoader = false;

          throw new Error(`Failed! Adding Interview Process:${error}`);
        }
      }
    },
    resetClone() {
      this.duplicateCloneName = false;
    },
    scrollFunctionality() {
      let element = document.getElementById("scrollToTop");
      if (element) {
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    resetMethod() {
      this.duplicateCloneName = false;
      this.editRound = false;
      this.searchQuery = "";
      this.showSearchLoader = true;
      this.page = 0;
      this.$nextTick(() => {
        this.scrollFunctionality();
      });
      this.$v.$reset();
      this.editorDiscardorDeleteRound("discard");
      this.getInterview();
    },
    addnewRound() {
      this.editRound = true;
      this.tabs.push({
        id: this.tabs.length + 1,
        name: "",
        type: "assesment",
        feedbackform: {
          name: "",
          feedbackFormID: "",
        },
        duration: "",
        randomizeTest: false,
        roundIndex: null,
        testID: [],
      });
      this.scrollToBottom();
    },
  },
};
</script>
<style>
.ip-opacity {
  opacity: 0.5;
}
</style>
